var FORMS_INFO = [
  {
    form_name: "rspswp_form",
    items: [
      {
        name: "NewPassword",
        errors: [
          {
            code: "newpswempty",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          },
          {
            code: "newpswchar",
            test: function(item) {
                if($.trim(item.val()).length >= 7 && $.trim(item.val()).length <= 18){
                    return false;
                } else {
                    return true;
                }
            }
          },
          {
            code: "newpswbadchar",
            test: function(item) {
                var pattern_specialChars = new RegExp(/[()^[\]:+<>]/);
                return pattern_specialChars.test(item.val());
            }
          },
          {
            code: "newpswdiversity",
            test: function(item) {
                var pattern_oneLetterOneNumber = new RegExp(/^(?=.*\d)(?=.*[a-zA-Z])/);
                return !pattern_oneLetterOneNumber.test(item.val());
            }
          },
          {
            code: "newpswspaces",
            test: function(item) {
                return item.val().indexOf(" ") >= 0;
            }
          }

        ]
      },
      {
        name: "NewPasswordConfirmation",
        errors: [
          {
            code: "newpswconfmatch",
            test: function(item) {
                return item.val() != $("input[name='NewPassword']").val();
            }
          }

        ]
      }

    ]
  },
  {
    form_name: "prlp_form",
    items: [
      {
        name: "Address",
        errors: [
          {
            code: "profaddr",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          }

        ]
      },
      {
        name: "Postcode",
        errors: [
          {
            code: "profpostcode",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          },
          {
            code: "profpostcodebad",
            test: function(item) {
                if($.trim(item.val()).length >= 6 && $.trim(item.val()).length <= 8){
                    return false;
                } else {
                    return true;
                }
            }
          }

        ]
      },
      {
        name: "City",
        errors: [
          {
            code: "proftown",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          },
          {
            code: "proftownbad",
            test: function(item) {
                return $.trim(item.val()).length <= 1;
            }
          }

        ]
      },
      {
        name: "Phone",
        errors: [
          {
            code: "profphone",
            test: function(item) {
                var pattern_phoneNumber = new RegExp(/^(\(?(0|\+44|0044)[1-9]{1}\d{1,4}?\)?\s?\d{3,4}\s?\d{3,4})$/);
                return !pattern_phoneNumber.test(item.val());
            }
          }

        ]
      },
      {
        name: "Email",
        errors: [
          {
            code: "profmail",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          },
          {
            code: "profmailbad",
            test: function(item) {
                var pattern_email = new RegExp(/^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i);
                return !pattern_email.test(item.val());
            }
          }

        ]
      },
      {
        name: "EmailVerification",
        errors: [
          {
            code: "profmailconfbad",
            test: function(item) {
                return item.val() != item.parent("form").find("input[name='Email']").val();
            }
          }

        ]
      },
      {
        name: "CreditCard.Type.Id",
        errors: [
          {
            code: "profcctype",
            test: function(item) {
                return item.val() === "";
            }
          }

        ]
      },
      {
        name: "CBNumber",
        errors: [
          {
            code: "profccnb",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          }

        ]
      },
      {
        name: "CreditCard.ExpMonth",
        errors: [
          {
            code: "profccdates",
            test: function(item) {
                if(item.val() === "" && $("input[name='Year']").val() === ""){
                    return true;
                }
            }
          },
          {
            code: "profccdatemonth",
            test: function(item) {
                return item.val() === "";
            }
          }

        ]
      },
      {
        name: "CreditCard.ExpYear",
        errors: [
          {
            code: "profccdateyear",
            test: function(item) {
                return item.val() === "";
            }
          }

        ]
      }

    ]
  },
  {
    form_name: "chgpswp_form",
    items: [
      {
        name: "CurrentPassword",
        errors: [
          {
            code: "profcrtpsw",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          }

        ]
      },
      {
        name: "NewPassword",
        errors: [
          {
            code: "profnewpsw",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          },
          {
            code: "profnewpswsize",
            test: function(item) {
                if($.trim(item.val()).length >= 7 && $.trim(item.val()).length <= 18){
                    return false;
                } else {
                    return true;
                }
            }
          },
          {
            code: "profnewpswbadchar",
            test: function(item) {
                var pattern_specialChars = new RegExp(/[()^[\]:+<>]/);
                return pattern_specialChars.test(item.val());
            }
          },
          {
            code: "profnewpswdiversity",
            test: function(item) {
                var pattern_oneLetterOneNumber = new RegExp(/^(?=.*\d)(?=.*[a-zA-Z])/);
                return !pattern_oneLetterOneNumber.test(item.val());
            }
          },
          {
            code: "profnewpswspaces",
            test: function(item) {
                return item.val().indexOf(" ") >= 0;
            }
          }

        ]
      },
      {
        name: "NewPasswordConfirmation",
        errors: [
          {
            code: "profnewpswconfmatchissue",
            test: function(item) {
                return item.val() != $("input[name='NewPassword']").val();
            }
          }

        ]
      }

    ]
  },
  {
    form_name: "cbp_form",
    items: [
      {
        name: "merchant_id",
        errors: [
          {
            code: "bnfcbretail",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          }

        ]
      },
      {
        name: "email_tranx_date",
        errors: [
          {
            code: "bnfcbdate",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          },
          {
            code: "bnfcbdatelater",
            test: function(item) {
                var dateString  = item.val().replace(/[-_/]/g,'/');
                var dateArray   = dateString.split('/');
                var inputDay    = dateArray[0];
                var inputMonth  = dateArray[1];
                var inputYear   = dateArray[2];
                var myDate      = new Date();
                if(inputYear < myDate.getFullYear()){
                    return false;
                } else if (inputYear == myDate.getFullYear()){
                    if( inputMonth < myDate.getMonth()+1 ){
                         return false;
                    } else if(inputMonth == myDate.getMonth()+1 ){
                        if(inputDay <= myDate.getDate()){
                           return false;
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            }
          }

        ]
      },
      {
        name: "email_order_number",
        errors: [
          {
            code: "bnfcbpurch",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          }

        ]
      },
      {
        name: "email_tranx_amount",
        errors: [
          {
            code: "bnfcbamount",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          }

        ]
      },
      {
        name: "email_upload_file",
        errors: [
          {
            code: "bnfcbdocformat",
            test: function(item) {
              var file_extension = item.val().split('.').pop();
              if (in_array(file_extension, VALID_EXTENSIONS)) return false;
              else return true;
            }
          }
        ]
      },
    ]
  },
  {
    form_name: "mtcfp_form",
    items: [
      {
        name: "merchant_id",
        errors: [
          {
            code: "bnfcbretail",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          }

        ]
      },
      {
        name: "email_tranx_date",
        errors: [
          {
            code: "bnfcbdate",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          },
          {
            code: "bnfcbdatelater",
            test: function(item) {
                var dateString  = item.val().replace(/[-_/]/g,'/');
                var dateArray   = dateString.split('/');
                var inputDay    = dateArray[0];
                var inputMonth  = dateArray[1];
                var inputYear   = dateArray[2];
                var myDate      = new Date();
                if(inputYear < myDate.getFullYear()){
                    return false;
                } else if (inputYear == myDate.getFullYear()){
                    if( inputMonth < myDate.getMonth()+1 ){
                         return false;
                    } else if(inputMonth == myDate.getMonth()+1 ){
                        if(inputDay <= myDate.getDate()){
                           return false;
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            }
          }

        ]
      },
      {
        name: "email_order_number",
        errors: [
          {
            code: "bnfcbpurch",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          }

        ]
      },
      {
        name: "email_tranx_amount",
        errors: [
          {
            code: "bnfcbamount",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          }

        ]
      },
      {
        name: "email_upload_file",
        errors: [
          {
            code: "bnfcbdocformat",
            test: function(item) {
              var file_extension = item.val().split('.').pop();
              if (in_array(file_extension, VALID_EXTENSIONS)) return false;
              else return true;
            }
          }
        ]
      },

    ]
  },
  {
    form_name: "mmb_cf",
    items: [
      {
        name: "merchantname",
        errors: [
          {
            code: "bnfmmbretail",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          }

        ]
      },
      {
        name: "dateofpurchase",
        errors: [
          {
            code: "bnfmmbdate",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          },
          {
            code: "bnfmmbdatelater",
            test: function(item) {
                var dateString  = item.val().replace(/[-_/]/g,'/');
                var dateArray   = dateString.split('/');
                var inputDay    = dateArray[0];
                var inputMonth  = dateArray[1];
                var inputYear   = dateArray[2];
                var myDate      = new Date();
                if(inputYear < myDate.getFullYear()){
                    return false;
                } else if (inputYear == myDate.getFullYear()){
                    if( inputMonth < myDate.getMonth()+1 ){
                         return false;
                    } else if(inputMonth == myDate.getMonth()+1 ){
                        if(inputDay <= myDate.getDate()){
                           return false;
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            }
          }

        ]
      },
      {
        name: "purchasereference",
        errors: [
          {
            code: "bnfmmbpurch",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          }

        ]
      },
      {
        name: "email_upload_file",
        errors: [
          {
            code: "bnfmmbdocformat",
            test: function(item) {
              var file_extension = item.val().split('.').pop();
              if (in_array(file_extension, VALID_EXTENSIONS)) return false;
              else return true;
            }
          }
        ]
      },
    ]
  },
  {
    form_name: "mmbcfp_form",
    items: [
      {
        name: "merchantname",
        errors: [
          {
            code: "bnfmmbretail",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          }

        ]
      },
      {
        name: "dateofpurchase",
        errors: [
          {
            code: "bnfmmbdate",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          },
          {
            code: "bnfmmbdatelater",
            test: function(item) {
                var dateString  = item.val().replace(/[-_/]/g,'/');
                var dateArray   = dateString.split('/');
                var inputDay    = dateArray[0];
                var inputMonth  = dateArray[1];
                var inputYear   = dateArray[2];
                var myDate      = new Date();
                if(inputYear < myDate.getFullYear()){
                    return false;
                } else if (inputYear == myDate.getFullYear()){
                    if( inputMonth < myDate.getMonth()+1 ){
                         return false;
                    } else if(inputMonth == myDate.getMonth()+1 ){
                        if(inputDay <= myDate.getDate()){
                           return false;
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            }
          }

        ]
      },
      {
        name: "purchasereference",
        errors: [
          {
            code: "bnfmmbpurch",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          }

        ]
      },
      {
        name: "email_upload_file",
        errors: [
          {
            code: "bnfmmbdocformat",
            test: function(item) {
              var file_extension = item.val().split('.').pop();
              if (in_array(file_extension, VALID_EXTENSIONS)) return false;
              else return true;
            }
          }
        ]
      },
    ]
  },
  {
    form_name: "wrp_form",
    items: [
      {
        name: "merchantname",
        errors: [
          {
            code: "bnfotbretail",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          }

        ]
      },
      {
        name: "dateofpurchase",
        errors: [
          {
            code: "bnfotbdate",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          },
          {
            code: "bnfotbdatelater",
            test: function(item) {
                var dateString  = item.val().replace(/[-_/]/g,'/');
                var dateArray   = dateString.split('/');
                var inputDay    = dateArray[0];
                var inputMonth  = dateArray[1];
                var inputYear   = dateArray[2];
                var myDate      = new Date();
                if(inputYear < myDate.getFullYear()){
                    return false;
                } else if (inputYear == myDate.getFullYear()){
                    if( inputMonth < myDate.getMonth()+1 ){
                         return false;
                    } else if(inputMonth == myDate.getMonth()+1 ){
                        if(inputDay <= myDate.getDate()){
                           return false;
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            }
          }

        ]
      },
      {
        name: "purchasereference",
        errors: [
          {
            code: "bnfotbpurch",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          }

        ]
      },
      {
        name: "email_upload_file",
        errors: [
          {
            code: "bnfotbdocformat",
            test: function(item) {
              var file_extension = item.val().split('.').pop();
              if (in_array(file_extension, VALID_EXTENSIONS)) return false;
              else return true;
            }
          }
        ]
      },
    ]
  },
  {
    form_name: "otbcfp_form",
    items: [
      {
        name: "merchantname",
        errors: [
          {
            code: "bnfotbretail",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          }

        ]
      },
      {
        name: "dateofpurchase",
        errors: [
          {
            code: "bnfotbdate",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          },
          {
            code: "bnfotbdatelater",
            test: function(item) {
                var dateString  = item.val().replace(/[-_/]/g,'/');
                var dateArray   = dateString.split('/');
                var inputDay    = dateArray[0];
                var inputMonth  = dateArray[1];
                var inputYear   = dateArray[2];
                var myDate      = new Date();
                if(inputYear < myDate.getFullYear()){
                    return false;
                } else if (inputYear == myDate.getFullYear()){
                    if( inputMonth < myDate.getMonth()+1 ){
                         return false;
                    } else if(inputMonth == myDate.getMonth()+1 ){
                        if(inputDay <= myDate.getDate()){
                           return false;
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            }
          }

        ]
      },
      {
        name: "purchasereference",
        errors: [
          {
            code: "bnfotbpurch",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          }

        ]
      },
      {
        name: "email_upload_file",
        errors: [
          {
            code: "bnfotbdocformat",
            test: function(item) {
              var file_extension = item.val().split('.').pop();
              if (in_array(file_extension, VALID_EXTENSIONS)) return false;
              else return true;
            }
          }
        ]
      },

    ]
  },
  {
    form_name: "ctctp_form",
    items: [
      {
        name: "subject",
        errors: [
          {
            code: "cttopic",
            test: function(item) {
                return item.val() === "";
            }
          }

        ]
      },
      {
        name: "purchasereceipt",
        errors: [
          {
            code: "ctmsg",
            test: function(item) {
                if(item.val().length === 0 || item.val() == " "){
                    return true;
                } else {
                    return false;
                }
            }
          }

        ]
      }

    ]
  },
  {
      form_name: "cffp",
      items: [
        {
            name: "selectedFeedBackCategoryId",
            errors: [
              {
                  code: "cffpfeedbackSourceId",
                  test: function (item) {
                      return item.val() === "";
                  }
              }

            ]
        }

      ]
  }
];
